import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ipbx-app',
    template: `<router-outlet></router-outlet>`
})
export class IPBXComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/app.component.ts